<template>
<div>
    Da implementare, qui si potranno visualizzare le statistiche generali sull'utilizzo dell'applicazione
</div>    
</template>
